module.exports = __webpack_public_path__ + "static/media/Logo.329a3847.png";